// extracted by mini-css-extract-plugin
export default {"successImg":"Success_successImg__YtH1d","contentWrapper":"Success_contentWrapper__4sQzo","title":"Success_title__jMxTb","text":"Success_text__6bzRX"};